import React, { useEffect, useState } from "react";
import env from "../../../env";
import errortrans from "../../../translate/error";
import formtrans from "../../../translate/forms";
import UploadImage from "./UploadImage";
import UploadVideo from "./UploadVideo";
import UploadDetails from "./UploadDetails";
import Cookies from "universal-cookie";

const cookies = new Cookies();

function UploadDetailHolder(props) {
  const url = window.location.pathname.split("/")[3];
  const direction = props.lang ? props.lang.dir : errortrans.defaultDir;
  const lang = props.lang ? props.lang.lang : errortrans.defaultLang;

  const [error, setError] = useState({
    errorText: "",
    errorColor: "brown",
  });

  const token = cookies.get(env.cookieName);

  const [content, setContent] = useState("");
  const [sliderChange, setSliderChange] = useState({});

  // وضعیت آپلود هر فایل
  const [uploadStatus, setUploadStatus] = useState({});

  /*
    مثال:
    {
      imageUrl: "success",
      imageUrl2: "uploading",
      imageUrl3: "idle",
      videoUrl: "success"
    }
  */

  const handleUploadStatus = (key, status) => {
    setUploadStatus((prev) => ({
      ...prev,
      [key]: status,
    }));
  };

  useEffect(() => {
    if (url === "new") return;

    const postOptions = {
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ downId: url }),
    };

    fetch(env.siteApi + "/panel/document/fetch-download", postOptions)
      .then((res) => res.json())
      .then(
        (result) => {
          if (result.error) {
            setError({
              errorText: result.error,
              errorColor: "brown",
            });

            setTimeout(
              () =>
                setError({
                  errorText: "",
                  errorColor: "brown",
                }),
              3000,
            );
          } else {
            setError({
              errorText: "سرویس پیدا شد",
              errorColor: "green",
            });

            setContent(result.filter);

            setTimeout(
              () =>
                setError({
                  errorText: "",
                  errorColor: "brown",
                }),
              2000,
            );
          }
        },
        (error) => {
          console.log(error);
        },
      );
  }, []);

  /*
    بررسی اینکه آیا هنوز آپلودی در حال انجام است
  */
  const isUploading = Object.values(uploadStatus).some(
    (status) => status === "uploading",
  );

  /*
    بررسی اینکه آیا آپلودی خطا داشته
  */
  const hasUploadError = Object.values(uploadStatus).some(
    (status) => status === "error",
  );

  const saveSlider = () => {
    // اگر هنوز آپلود تمام نشده
    if (isUploading) {
      setError({
        errorText: "لطفاً تا پایان آپلود فایل صبر کنید",
        errorColor: "brown",
      });

      setTimeout(
        () =>
          setError({
            errorText: "",
            errorColor: "brown",
          }),
        3000,
      );

      return;
    }

    // اگر آپلود خطا داشته
    if (hasUploadError) {
      setError({
        errorText: "آپلود فایل با خطا مواجه شده است",
        errorColor: "brown",
      });

      setTimeout(
        () =>
          setError({
            errorText: "",
            errorColor: "brown",
          }),
        3000,
      );

      return;
    }

    const postOptions = {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token && token.token,
        userId: token && token.userId,
      },
      body: JSON.stringify({
        downId: url,
        ...sliderChange,
      }),
    };

    fetch(env.siteApi + "/panel/document/update-download", postOptions)
      .then((res) => res.json())
      .then(
        (result) => {
          if (result.error) {
            setError({
              errorText: result.error,
              errorColor: "brown",
            });

            setTimeout(
              () =>
                setError({
                  errorText: "",
                  errorColor: "brown",
                }),
              3000,
            );
          } else {
            setError({
              errorText: result.success,
              errorColor: "green",
            });

            setTimeout(() => (window.location.href = "/Upload"), 2000);
          }
        },
        (error) => {
          console.log(error);
        },
      );
  };

  return (
    <div className="new-item" style={{ direction }}>
      <div className="create-product">
        <h4>ویرایش {content?.title}</h4>

        {content || url === "new" ? (
          <div className="pages-wrapper">
            <div className="item-box" style={{ paddingBottom: "4rem" }}>
              <div className="imageHolder">
                {/* <UploadDetails
                  lang={lang}
                  content={content}
                  setSliderChange={setSliderChange}
                /> */}
                {content?.position == "5" ? (
                  <UploadVideo
                    lang={lang}
                    content={content}
                    value="videoUrl"
                    sliderChange={sliderChange}
                    part={1}
                    setSliderChange={setSliderChange}
                    onUploadStatus={handleUploadStatus}
                  />
                ) : (
                  <UploadImage
                    lang={lang}
                    content={content}
                    value="imageUrl"
                    sliderChange={sliderChange}
                    part={1}
                    setSliderChange={setSliderChange}
                    onUploadStatus={handleUploadStatus}
                  />
                )}

                {content?.position == "1" ||
                  (content?.position == "6" && (
                    <>
                      <UploadImage
                        lang={lang}
                        content={content}
                        value="imageUrl2"
                        sliderChange={sliderChange}
                        part={2}
                        setSliderChange={setSliderChange}
                        onUploadStatus={handleUploadStatus}
                      />

                      <UploadImage
                        lang={lang}
                        content={content}
                        value="imageUrl3"
                        sliderChange={sliderChange}
                        part={3}
                        setSliderChange={setSliderChange}
                        onUploadStatus={handleUploadStatus}
                      />
                    </>
                  ))}

                {content?.position !== 1 &&
                  content?.position !== 5 &&
                  content?.position !== 6 && (
                    <>
                      <h5 style={{ marginBlock: "1rem" }}>موبایل</h5>
                      <UploadImage
                        lang={lang}
                        content={content}
                        value="mobileUrl"
                        sliderChange={sliderChange}
                        part={4}
                        setSliderChange={setSliderChange}
                        onUploadStatus={handleUploadStatus}
                      />
                    </>
                  )}
              </div>
            </div>

            <div className="create-btn-wrapper">
              <div
                className={`save-btn ${
                  isUploading || hasUploadError ? "save-btn-disabled" : ""
                }`}
                onClick={
                  !isUploading && !hasUploadError ? saveSlider : undefined
                }
                style={{
                  opacity: isUploading || hasUploadError ? 0.5 : 1,
                  cursor:
                    isUploading || hasUploadError ? "not-allowed" : "pointer",
                }}
              >
                {isUploading ? "در حال آپلود..." : formtrans.saveChanges[lang]}
              </div>

              <div
                className="cancel-btn"
                onClick={() => (window.location.href = "/Upload")}
              >
                {formtrans.cancel[lang]}
              </div>
            </div>
          </div>
        ) : (
          <div>{env.loader}</div>
        )}
      </div>
    </div>
  );
}

export default UploadDetailHolder;
